import React  from 'react';

const Start = () => { 
    return <div><img  width="100%" alt='Hier ist ein Bild' src="./Bilder/Startbild.JPG" /></div> 
}

export default Start